import classNames from 'classnames'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

import { Theme } from '@mui/material'

import { SubspaceFilters } from '../../components/SubspaceFilters'
import { useSubspaceListViewStore } from './SubspaceListViewStore'

export type CorporateListViewActionsProps = {
  className?: string
}

export function SubspaceListViewActions({ className }: CorporateListViewActionsProps) {
  const {
    state: { filters },
    actions: { setFilters },
  } = useSubspaceListViewStore()
  const { classes } = useStyles()
  return (
    <div className={classNames(className, classes.container)}>
      <SubspaceFilters filters={filters} onChange={setFilters} />
    </div>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  container: {
    display: 'flex',
  },
  button: {
    textDecoration: 'none',
    marginLeft: spacing(2),
  },
}))
